import { useEffect } from 'react';

export function ThemeInjector({
    settings = {},
}: {
    settings?: Record<string, string>;
}) {
    useEffect(() => {
        const root = document.documentElement;

        // Iterar sobre todos los settings en búsqueda de colores
        Object.entries(settings).forEach(([key, value]) => {
            if (key.startsWith('color_') && value) {
                // Generar el nombre real de la variable css, por ejemplo 'color_sidebar_primary' a '--sidebar-primary'
                const cssVar = `--${key.replace('color_', '').replace(/_/g, '-')}`;

                // En Tailwind V4 base, las utilidades esperan el color directamente en formato HEX a menos que se haya forzado OKLCH
                // El navegador puede resolver HEX nativo para root vars.
                root.style.setProperty(cssVar, value);
            }
        });

        // Manejo del favicon dinámico
        if (settings.app_favicon) {
            let link = document.querySelector(
                "link[rel~='icon']",
            ) as HTMLLinkElement;
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            link.href = settings.app_favicon;
        }
    }, [settings]);

    return null;
}
